/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ListType/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ListType({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/Content/ActiveStep/ListType"
  
}) {
  return null
}